import CultureStackedChart from '../Graph/CultureStackedChart';
import DistributionSection from '../Components/DistributionSection';
import { useTranslation } from 'react-i18next';

const SectionCrops = ({
  pieChartData,
  interculturePieChartData,
  cultures,
  totalExploitationSurface,
  currentPieIndex,
  setCurrentPieIndex,
  forcedChartMode,
  stackedOpen,
  setStackedOpen,
}) => {
  const { t } = useTranslation();
  const hasIntercrops = !!cultures.find((cult) => cult.type === 'intermediate');

  return (
    <>
      <DistributionSection
        title={t('simulation.result.cultures.distributionTitle')}
        idPrefixForPdf="pie-chart"
        pieChartData={pieChartData}
        currentIndex={currentPieIndex}
        onIndexChange={setCurrentPieIndex}
      />
      {hasIntercrops && (
        <DistributionSection
          title={t('simulation.result.cultures.interculturesDistributionTitle')}
          idPrefixForPdf="pie-chart-interculture"
          pieChartData={interculturePieChartData}
          totalSurface={totalExploitationSurface}
          currentIndex={currentPieIndex}
          onIndexChange={setCurrentPieIndex}
        />
      )}
      <CultureStackedChart
        id="stacked-chart-cultures"
        pieChartData={pieChartData}
        title={t('simulation.result.cultures.evolutionTitle')}
        forcedMode={forcedChartMode}
        isOpen={stackedOpen.cultures}
        onToggle={() => setStackedOpen((prev) => ({ ...prev, cultures: !prev.cultures }))}
      />
      {hasIntercrops && (
        <CultureStackedChart
          id="stacked-chart-intercultures"
          pieChartData={interculturePieChartData}
          title={t('simulation.result.cultures.interculturesEvolutionTitle')}
          forcedMode={forcedChartMode}
          isOpen={stackedOpen.intercultures}
          onToggle={() =>
            setStackedOpen((prev) => ({ ...prev, intercultures: !prev.intercultures }))
          }
        />
      )}
    </>
  );
};

export default SectionCrops;
